(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trade-policy', {
            parent: 'entity',
            url: '/trade-policy?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicy.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy/trade-policies.html',
                    controller: 'TradePolicyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trade-policy-detail', {
            parent: 'entity',
            url: '/trade-policy/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicy.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy/trade-policy-detail.html',
                    controller: 'TradePolicyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicy');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TradePolicy', function($stateParams, TradePolicy) {
                    return TradePolicy.get({id : $stateParams.id});
                }]
            }
        })
        .state('trade-policy.new', {
            parent: 'trade-policy',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy/trade-policy-dialog.html',
                    controller: 'TradePolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                fromDate: null,
                                toDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('trade-policy', null, { reload: true });
                }, function() {
                    $state.go('trade-policy');
                });
            }]
        })
        .state('trade-policy.edit', {
            parent: 'trade-policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy/trade-policy-dialog.html',
                    controller: 'TradePolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TradePolicy', function(TradePolicy) {
                            return TradePolicy.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trade-policy.delete', {
            parent: 'trade-policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy/trade-policy-delete-dialog.html',
                    controller: 'TradePolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TradePolicy', function(TradePolicy) {
                            return TradePolicy.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
